import PropTypes from "prop-types"
import { FormLabel, Grid } from "@mui/material"
import { CheckboxMultiple, RadioButton } from "components/fields"
import { useFormContext } from "react-hook-form"
import consentement from "json/consentement.json"
import { useEffect } from "react"

const ConsentementMultiple = ({ optinNL = false, callOptIn = false }) => {

  const { control, setValue, watch } = useFormContext()

  const watchConsentement = watch('consentement')
  const watchConsent = watch('consent')

  const getConsentementOptions = () => {
    if (optinNL) {
      return consentement.filter(el =>
        el.field === 'lead.OptIn_SMS__c' ||
        el.field === 'lead.OptIn_WhatsApp__c'
      )
    }
    return consentement
  }
  const consentementOptions = getConsentementOptions()
  const callOption = consentementOptions.find((option) => option.field === 'lead.OptIn_Call__c')
  const isCallForced = callOptIn && watchConsent === 'Non' && Boolean(callOption)

  const consentementOptionsWithDisabledCall = consentementOptions.map((option) => (
    option.field === 'lead.OptIn_Call__c'
      ? { ...option, disabled: isCallForced }
      : option
  ))

  useEffect(() => {
    if (optinNL) {
      setValue('lead.OptIn_Email__c', true)
    }
  }, [optinNL, setValue])

  useEffect(() => {
    if (watchConsent === 'Oui') {
      consentementOptions.forEach(el => {
        setValue(el.field, true)
      })
    } else if (watchConsent === 'Non') {
      if (!watchConsentement || watchConsentement.length === 0) {
        consentementOptions.forEach(el => {
          setValue(el.field, false)
        })
        if (isCallForced) {
          setValue('lead.OptIn_Call__c', true)
        }
      }
    }
  }, [watchConsent, consentementOptions, setValue, watchConsentement, isCallForced])

  useEffect(() => {
    if (!isCallForced || !callOption) {
      return
    }

    const selected = Array.isArray(watchConsentement) ? watchConsentement : []
    if (!selected.includes(callOption.value)) {
      setValue('consentement', [...selected, callOption.value])
    }
    setValue('lead.OptIn_Call__c', true)
  }, [isCallForced, callOption, watchConsentement, setValue])

  useEffect(() => {
    if (watchConsent === 'Oui') return // Ne pas gérer les checkboxes si "Oui" est sélectionné

    if (watchConsentement?.length > 0) {
      const mapConsentement = consentementOptions
        .filter(el => watchConsentement.some(el2 => el.label === el2))
        .map(el => el.field)

      if (isCallForced && !mapConsentement.includes('lead.OptIn_Call__c')) {
        mapConsentement.push('lead.OptIn_Call__c')
      }

      for (const consent of mapConsentement) {
        setValue(consent, true)
      }
      consentementOptions
        .filter(el => !mapConsentement.includes(el.field))
        .forEach(el => setValue(el.field, false))
    } else {
      consentementOptions.forEach(el => {
        setValue(el.field, false)
      })
      if (isCallForced) {
        setValue('lead.OptIn_Call__c', true)
      }
    }
  }, [watchConsentement, consentementOptions, setValue, watchConsent, isCallForced])

  const consent = [
    { label: 'Oui', value: 'Oui' },
    { label: 'Non', value: 'Non' }
  ]

  return (
    <>
    {optinNL && (<Grid item xs={12}> <FormLabel>En soumettant ce formulaire, j'accepte d'être recontacté par email.</FormLabel> </Grid> )}
      {!optinNL && (
        <Grid item xs={12}>
          <RadioButton
            control={control}
            label="J'accepte d'être contacté par email, messagerie et appel téléphonique"
            name="consent"
            options={consent}
            required
          />
        </Grid>
      )}
      {watchConsent === 'Non' && (
        <Grid item xs={12}>
          <CheckboxMultiple
            control={control}
            label="J'accepte d'être contacté par email, messagerie et appel téléphonique pour recevoir des communications personnalisées"
            name="consentement"
            options={consentementOptionsWithDisabledCall}
          />
        </Grid>
      )}
    </>
  )
}

ConsentementMultiple.propTypes = {
  optinNL: PropTypes.bool,
  callOptIn: PropTypes.bool
}

export default ConsentementMultiple
